import dayjs from 'dayjs';

import { useState } from 'react';

import { Space, Select, DatePicker } from 'antd';

import * as Constants from '../../constants';

const { RangePicker } = DatePicker;

const FilterDateSelector = ({ options, onFilterApply, presets, futureType }) => {
  const [selectedValue, setSelectedValue] = useState(options?.[0].value);
  // const [datesWindow, setDatesWindow] = useState([]);
  const handleDateRangeChange = (dates) => {
    if (!dates) {
      onFilterApply('date_range', selectedValue, [undefined, undefined]);
      return;
    }
    if (dates.some((date) => !date)) return;
    onFilterApply('date_range', selectedValue, [
      dates[0].startOf('date')?.toISOString(),
      dates[1].endOf('date')?.toISOString()
    ]);
  };
  return (
    <Space className="g-0">
      <Select
        // style={{ width: 120 }}
        className="group__select"
        defaultValue={options?.[0].value}
        onChange={(value) => {
          setSelectedValue(value);
        }}
        options={options}
        value={selectedValue}
      />
      <RangePicker
        allowEmpty={[true, true]}
        className="date__left__radiius__0"
        disabledDate={
          !futureType.includes(selectedValue) ? (current) => current && current > dayjs().endOf('day') : undefined
        }
        format={Constants.DATE_FORMAT}
        onChange={handleDateRangeChange}
        presets={presets}
        style={{ width: 220 }}
        value={[undefined, undefined]}
      />
    </Space>
  );
};

export default FilterDateSelector;
